<template>
    <div class="side-menu sidebar-inverse">
        <nav class="navbar navbar-default" role="navigation">
            <div class="side-menu-container">
                <div class="navbar-header">
                    <a class="navbar-brand" href="#">
                        <div class="icon pull-left">
                            <img src="/img/pelican.png">
                        </div>
                        <div class="title">Pelican™</div>
                    </a>
                    <button
                            v-on:click="$emit('menu:close')"
                            type="button" class="navbar-expand-toggle pull-right visible-xs">
                        <i class="fa fa-times icon"></i>
                    </button>
                </div>
                <ul class="nav navbar-nav">
                    <li>
                        <!-- INFO: native event, sort of hack to allow an onclick on a RouterLink... -->
                        <!-- maybe this menu closing job can be done in some router lifecycle hook ? -->
                        <RouterLink to="jobs" v-on:click.native="$emit('menu:close')">
                            <i class="icon fa fa-list"></i>
                            <span class="title">{{'Today'|trans}}</span>
                        </RouterLink>
                    </li>

                    <li>
                        <RouterLink to="availabilities" v-on:click.native="onAvailabilitiesClick">
                            <i class="icon fa fa-calendar"></i>
                            <span class="title">{{ 'Calendar 30 days' | trans }}</span>
                        </RouterLink>
                    </li>

                    <li >
                        <RouterLink to="skills" v-on:click.native="$emit('menu:close')">
                            <i class="icon fa fa-wrench"></i>
                            <span class="title">{{ 'My skills' | trans }}</span>
                        </RouterLink>
                    </li>
                    <li v-if="user.isPureContact && user.workerIsNovice !== true">
                        <RouterLink to="invoices" v-on:click.native="$emit('menu:close')">
                            <i class="icon fa fa-file-pdf-o"></i>
                            <span class="title">{{ 'Invoices' | trans }}</span>
                        </RouterLink>
                    </li>
                    <li v-if="user.isPureContact && user.workerIsNovice !== true">
                        <RouterLink to="balance_and_transactions" v-on:click.native="$emit('menu:close')">
                            <i class="icon fa fa-money"></i>
                            <span class="title">{{ 'Transactions' | trans }}</span>
                        </RouterLink>
                    </li>

                    <li>
                        <a href="tel:003228281450" aria-expanded="false">
                            <i class="icon fa fa-phone"></i>
                            <span class="title">{{ 'Call Bureau' | trans }}</span>
                        </a>
                    </li>

                    <li>
                        <RouterLink to="missed_jobs" v-on:click.native="$emit('menu:close')">
                            <i class="icon fa">🤦🏻&zwj;♂️&zwnj;</i>
                            <span class="title">{{ 'Missed opportunities' | trans }}</span>
                        </RouterLink>
                    </li>

                    <li >
                        <RouterLink to="new_job" v-on:click.native="$emit('menu:close')">
                            <i class="icon fa fa-plus-circle">️&zwnj;</i><span class="title">{{ 'New Job' | trans }}</span>
                        </RouterLink>
                    </li>

                    <li >
                        <RouterLink :to="{name:'job_list'}" v-on:click.native="$emit('menu:close')">
                            <i class="icon fa fa-plus-circle">️&zwnj;</i><span class="title">{{ 'My own customers' | trans }}</span>
                        </RouterLink>
                    </li>



                    <li>
                        <RouterLink to="leads" v-on:click.native="$emit('menu:close')">
                            <i class="icon fa fa-money"></i>
                            <span class="title">{{ 'My leads' | trans }} <span class="tag small tag-success">new</span></span>

                        </RouterLink>
                    </li>

                    <li>
                        <RouterLink to="preferences" v-on:click.native="$emit('menu:close')">
                            <i class="icon fa fa-gears"></i>
                            <span class="title">{{ 'Settings' | trans }}</span>
                        </RouterLink>
                    </li>

                    <li>
                        <a v-bind:href="logoutUrl()" aria-expanded="false">
                            <i class="icon fa fa-sign-out"></i>
                            <span class="title">{{ 'Logout' | trans }}</span>
                        </a>
                    </li>

                </ul>
            </div>
        </nav>
    </div>
</template>

<script>
    export default {
        props : {
          user : Object
        },
        methods: {
			logoutUrl() {
				// REMARK: not possible to use Routing.js for this route, because this route is internal in FOSUserBundle
				return process.env.VUE_APP_API_BASE_URL + '/admin/logout';
			},
            onAvailabilitiesClick() {
                this.$emit('menu:close');
                if (this.$router.currentRoute.name === 'availabilities') {
                    // WARNING: ugly hack, modification of a data of Availabilities component, to allow returning
                    // on 'days list' screen when clicking on 'availabilities' menu entry from 'day edit' screen
                    this.$parent.$children[1].editedDay = null;
                }
            }
        }
    }
</script>
